import * as React from 'react'

import { cn } from '@/lib/utils'

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[72px] w-full rounded-lg border border-input bg-card/70 px-3 py-2 text-base text-foreground shadow-none transition-[border-color,box-shadow,background-color] duration-150 placeholder:text-muted-foreground/80 hover:border-foreground/25 focus-visible:border-primary/70 focus-visible:bg-card focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/12 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
